module.exports = "/shifts/components/dayOptionsComponent-678701.html";